export var Globals;
(function (Globals) {
    var firestore = null;
    function setFirestore(fs) {
        firestore = fs;
    }
    Globals.setFirestore = setFirestore;
    function getFirestore() {
        if (!firestore) {
            throw new Error(`setFirestore() must be called with firestore instance before interacting with the database`);
        }
        return firestore;
    }
    Globals.getFirestore = getFirestore;
})(Globals || (Globals = {}));
//# sourceMappingURL=globals.js.map